import http from 'plugins/axios';

export default {
    getUsers(data) {
        return http.get({
            url: '/admin/email/group/user/email/group/users',
            data
        })
    },
    groupList(data) {
        return http.get({
            url: '/admin/email/group/list',
            data
        })
    },
    edit(data) {
        return http.post({
            url: '/admin/email/group/user/email/group/updateUserGroup',
            data,
            dataType: 'form'
        })
    },
};
